import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import buildCriteriaQuery from '@/shared/criteria/criterias';

import { ICheckListTpl } from '@/shared/model/check-list-tpl.model';

const baseApiUrl = 'api/check-list-tpls';

export default class CheckListTplService {
  public find(id: number): Promise<ICheckListTpl> {
    return new Promise<ICheckListTpl>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    // console.log(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`);
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ICheckListTpl): Promise<ICheckListTpl> {
    return new Promise<ICheckListTpl>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICheckListTpl): Promise<ICheckListTpl> {
    return new Promise<ICheckListTpl>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public writeLog(text: String): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/writeLog/${text}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCompanyId(companyId: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/get-by-company/${companyId}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
